import { Building2, Building, Compass, Globe, GraduationCap, Landmark, Lightbulb, Sprout, Target, UserRound, Users, Briefcase, Handshake } from "lucide-react";

export const DIVISIONS = [
  {
    key: "academy",
    index: "01",
    name: "VION AI Academy",
    badge: "Education",
    to: "/ai-academy",
    cta: "Explore AI Academy",
    image: "/images/div-academy.webp",
    alt: "Young African technologists collaborating around laptops during a hands-on coding session",
    summary: "Practical technology education for individuals, professionals, young people and organisations.",
    areas: ["Artificial Intelligence", "Generative AI", "Prompt Engineering", "AI Automation", "AI Agents", "Cloud Computing", "DevOps", "Digital Skills", "Corporate AI Training", "Youth Technology Programmes"],
  },
  {
    key: "solutions",
    index: "02",
    name: "VION AI Solutions",
    badge: "Business",
    to: "/ai-solutions",
    cta: "Explore AI Solutions",
    image: "/images/div-solutions.webp",
    alt: "Professional working on a laptop at a modern workspace",
    summary: "Helping businesses and institutions use AI, automation and technology to improve productivity and efficiency.",
    areas: ["AI Agents", "Business Process Automation", "Workflow Automation", "CRM Automation", "AI Integration", "Digital Transformation", "Technology Consulting", "Business Process Improvement", "Cloud & Digital Solutions"],
  },
  {
    key: "consult",
    index: "03",
    name: "VION Consult",
    badge: "Global",
    to: "/vion-consult",
    cta: "Explore VION Consult",
    image: "/images/div-consult.webp",
    alt: "Desk globe in warm light, representing international education and global opportunity",
    summary: "Helping individuals navigate career, education, travel, relocation and global opportunities.",
    areas: ["Career Development", "International Education", "Study Abroad", "Admissions Support", "Travel Consulting", "Relocation Consulting", "Global Opportunity Advisory"],
  },
];

export const WHY = [
  { title: "Practical", text: "We focus on practical knowledge and solutions that can be applied in the real world." },
  { title: "Future-Focused", text: "We stay focused on emerging technologies and changing market needs." },
  { title: "People-Centred", text: "Technology should empower people. Our solutions and education are designed around real human needs." },
  { title: "Impact-Driven", text: "We aim to create meaningful outcomes through skills, innovation, technology and opportunity." },
];

export const AUDIENCES = [
  { title: "Individuals", icon: UserRound },
  { title: "Students & Young People", icon: GraduationCap },
  { title: "Professionals", icon: Briefcase },
  { title: "Businesses", icon: Building },
  { title: "Corporations", icon: Building2 },
  { title: "Educational Institutions", icon: Landmark },
  { title: "Government & Development Organisations", icon: Compass },
  { title: "International Partners", icon: Globe },
];

export const VALUES = [
  { title: "Innovation", icon: Lightbulb, text: "Exploring new ideas and emerging technologies with curiosity and rigour." },
  { title: "Excellence", icon: Target, text: "Holding our education, solutions and service to a high standard." },
  { title: "Integrity", icon: Handshake, text: "Being honest, transparent and responsible in everything we do." },
  { title: "Collaboration", icon: Users, text: "Working alongside people and partners to achieve shared goals." },
  { title: "Impact", icon: Sprout, text: "Measuring our work by the meaningful difference it makes." },
];
